import { render, staticRenderFns } from "./AppMainNavigation.vue?vue&type=template&id=79effc9f&scoped=true&"
import script from "./AppMainNavigation.vue?vue&type=script&lang=js&"
export * from "./AppMainNavigation.vue?vue&type=script&lang=js&"
import style0 from "./AppMainNavigation.vue?vue&type=style&index=0&id=79effc9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79effc9f",
  null
  
)

export default component.exports